<!-- UPC Selection Step Content -->
<siq-filter-group
  [schemaController]="queryMode.schema$"
  [mapFn]="productMapFn"
  [initModel]="formData.upcFilters"
  (emitter)="filterGroupChanged($event)"
></siq-filter-group>
